import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import { PracticeAreas } from './PracticeAreas';
import { LegalHeadline } from './LegalHeadline';
import { Competence } from './counter/Competence';
import { MapSection } from '../../components/maps/map';
import { ContactSection } from './ContactSection';

export const LandingMain: React.FC = () => {
	return (
		<Box sx={{ bgcolor: '#FAFAFB', color: '#333' }}>
			{/* Hero / Intro */}
			<LegalHeadline />
			<Container sx={{ py: { xs: 2, md: 2 }}}>
				<Box sx={{ p: 2}}>
					<PracticeAreas />
				</Box>
				<Box sx={{ p: 2}}>
					<Competence />
				</Box>
				<Box>
					<Grid container spacing={2} sx={{ mt: { xs: 8, md: 12 }, height: { xs: 'auto', md: 400 } }}>
						<Grid size={{ xs: 12, sm: 5 }}>
							<ContactSection />
						</Grid>
						<Grid size={{ xs: 12, sm: 7 }}>
							<MapSection />
						</Grid>
					</Grid>
				</Box>
			</Container>
		</Box>
	);
};

